import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DraftsIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="m16.3 6.4-8 8a1 1 0 0 0-.3.5l-1 4A1 1 0 0 0 8.2 20l4-1c.2 0 .4-.1.5-.3l9.5-9.5A3.1 3.1 0 1 0 17.8 5l-1.5 1.5Zm3 0a1.1 1.1 0 0 1 1.5 1.5l-.8.8-1.6-1.6.8-.8Zm-2.3 2 1.6 1.6-7.1 7.1-.7.2v-.1l-1-1 .1-.7 7.1-7Z"
      clipRule="evenodd"
    />
    <path d="M1 6.1c0-.5.4-1 1-1h10a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm1 3a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2H2Zm-1 5c0-.5.4-1 1-1h3a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z" />
  </Icon>
));
export default DraftsIcon;
